




















































































































import { Component, Vue } from "vue-property-decorator";
import RestaurantModule from "@/store/restaurant";
import { edDays } from "@/types";

@Component
export default class RestaurantInfo extends Vue {
  private get restaurant() {
    return RestaurantModule.restaurant;
  }

  private get edDays() {
    return edDays;
  }

  private windowWidth: number | null = null;

  private mounted() {
    window.addEventListener("resize", this.calcWindowWidth);
    this.calcWindowWidth();
  }

  private calcWindowWidth() {
    this.windowWidth = window.innerWidth;
  }
}
